import { render, staticRenderFns } from "./molecule.introVideos.vue?vue&type=template&id=35b8bdaf"
import script from "./molecule.introVideos.vue?vue&type=script&lang=ts"
export * from "./molecule.introVideos.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports